
export function throwTraceError(msg:string, ...rest:any[]){
    console.error(msg, rest);
    console.trace(msg);
    throw new Error(msg);
}